import { MapElement } from 'vue-googlemaps/dist/vue-googlemaps.esm';

export default {
  mixins: [MapElement],

  render(h) {
    if (!this.$slots.default || this.$slots.default.length === 0) {
      return '';
    } else {
      return h('div', this.$slots.default);
    }
  },

  googleMapsReady() {
    const bounds = new window.google.maps.LatLngBounds();

    let shouldExpand = false;

    this.$children.forEach(item => {
      const marker = item.$_marker;
      if (!marker) {
        return;
      }

      if (marker && marker.getVisible()) {
        shouldExpand = true;
        bounds.extend(marker.getPosition());
      }
    });

    if (!shouldExpand) {
      // eslint-disable-next-line no-console
      console.error('no bounds to expand');
      return;
    }

    this.$_map.fitBounds(bounds);
  },
};
